import React from 'react';

const OPERATORS = ['eq', 'neq', 'in', 'contains', 'gt', 'gte', 'lt', 'lte', 'exists'];

const ConditionRow = ({ condition, onChange, onRemove }) => (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px 1fr 40px', gap: '12px', alignItems: 'center' }}>
        <input
            className="crm-input"
            placeholder="field (e.g. lead.status)"
            value={condition.field || ''}
            onChange={(e) => onChange({ ...condition, field: e.target.value })}
        />
        <select
            className="crm-select"
            value={condition.op || 'eq'}
            onChange={(e) => onChange({ ...condition, op: e.target.value })}
        >
            {OPERATORS.map((op) => (
                <option key={op} value={op}>{op}</option>
            ))}
        </select>
        <input
            className="crm-input"
            placeholder="value"
            value={condition.value ?? ''}
            onChange={(e) => onChange({ ...condition, value: e.target.value })}
            disabled={condition.op === 'exists'}
        />
        <button className="crm-btn crm-btn-secondary crm-btn-sm" type="button" onClick={onRemove}>
            ✕
        </button>
    </div>
);

export default ConditionRow;
